import { render, staticRenderFns } from "./ContractField.vue?vue&type=template&id=faa86f0a"
import script from "./ContractField.vue?vue&type=script&lang=js"
export * from "./ContractField.vue?vue&type=script&lang=js"
import style0 from "./ContractField.vue?vue&type=style&index=0&id=faa86f0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports